<template>
  <div class="ReLike">
    <span class="btn btn-simple" :class="[{'text-primary':  showlk}, {'text-danger': !showlk}]">
      <i
        class="tim-ic ic-smile mr-1"
        :class="[{'show d-inline-block':  showlk}, {'d-none': !showlk}]"
        title="Нравится"
      ></i>
      <i
        class="tim-ic ic-sad mr-1"
        :class="[{'show d-inline-block': !showlk}, {'d-none':  showlk}]"
        title="Не нравится"
      ></i>
      {{counter}}
    </span>
  </div>
</template>

<script>
export default {
  name: "ReLike",
  components: {},
  props: {
    counter: String,
    findId: {
      type: String,
      default: ""
    },
    liketype: {
      type: String,
      default: "like"
    }
  },
  data() {
    return {
      ver: 1
    };
  },
  computed: {
    showlk: function() {
      //console.warn("showlk " + this.liketype);
      if (this.liketype == "dislike") {
        return false;
      } else {
        return true;
      }
    }
  },
  methods: {}
};
</script>
<style scoped>
.ReLike .social-state {
  display: flex;
  flex-grow: 1;
  padding-right: 10px;
}
.ReLike .social-state a {
  margin-right: 20px;
}
.ReLike .views-reached {
  display: flex;
  flex-shrink: 1;
}
.ReLike .post-footer-container {
  display: flex;
  padding: 20px 0;
}
.ic-smile::before,
.ic-sad::before,
.ic-eye::before,
.icon-chat-33::before {
  margin-right: 5px;
  font-size: 1.4rem;
  padding-top: 5px;
}
.ReLike .btn-simple {
  border: transparent;
  padding: 0;
}
.ReLike .btn-simple:hover {
  box-shadow: none;
  opacity: 0.6;
}
</style>
